/* eslint-disable react/require-default-props */
import React from 'react';
import { IoCheckmarkCircle, IoCloseCircle } from 'react-icons/io5';

import TokenInput from 'design-system/TokenInput';

import {
  Actions,
  Column,
  FormBody,
  Intro,
  OutlineButton,
  PrimaryButton,
  Subtitle,
  Title,
} from '../AuthForm/styles';
import { formatarRestante } from '../useCountdown';
import { Countdown } from './styles';

export type TokenStatus = 'aguardando' | 'validado' | 'invalido';

export type TokenStepProps = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  codigo: string;
  status: TokenStatus;
  restante: number;
  expirado: boolean;
  loading?: boolean;
  length?: number;
  submitLabel?: string;
  invalidMessage?: React.ReactNode;
  onChangeCodigo: (codigo: string) => void;
  onConfirmar: () => void;
  onReenviar: () => void;
  onBack: () => void;
  onTrocarCanal: () => void;
};

const TAMANHO_PADRAO = 6;

const TokenStep: React.FC<TokenStepProps> = ({
  title,
  subtitle,
  codigo,
  status,
  restante,
  expirado,
  loading = false,
  length = TAMANHO_PADRAO,
  submitLabel = 'Confirmar',
  invalidMessage = 'Token inválido ou expirado',
  onChangeCodigo,
  onConfirmar,
  onReenviar,
  onBack,
  onTrocarCanal,
}) => {
  if (expirado) {
    return (
      <Column gap={24}>
        <Intro>
          <Title>Tempo excedido!</Title>
          <Subtitle>
            Clique em &quot;reenviar código&quot; e tente novamente
          </Subtitle>
        </Intro>
        <Actions>
          <OutlineButton
            type="button"
            variant="secondary"
            shape="pill"
            fullWidth
            onClick={onTrocarCanal}
          >
            Tentar de outra maneira
          </OutlineButton>
          <PrimaryButton
            type="button"
            shape="pill"
            fullWidth
            disabled={loading}
            onClick={onReenviar}
          >
            {loading ? 'Reenviando...' : 'Reenviar código'}
          </PrimaryButton>
        </Actions>
      </Column>
    );
  }

  const invalido = status === 'invalido';

  const mensagem = ((): React.ReactNode => {
    if (status === 'validado') return 'Token validado';
    if (invalido) return invalidMessage;
    return <Countdown>{formatarRestante(restante)}</Countdown>;
  })();

  const icone = ((): React.ReactNode => {
    if (status === 'validado') return <IoCheckmarkCircle aria-hidden="true" />;
    if (invalido) return <IoCloseCircle aria-hidden="true" />;
    return null;
  })();

  return (
    <Column gap={24}>
      <Intro>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Intro>

      <FormBody>
        <TokenInput
          value={codigo}
          onChange={onChangeCodigo}
          length={length}
          error={invalido}
          disabled={loading}
          message={mensagem}
          messageIcon={icone}
        />

        <Actions>
          <OutlineButton
            type="button"
            variant="secondary"
            shape="pill"
            fullWidth
            onClick={onBack}
          >
            Voltar
          </OutlineButton>
          {invalido ? (
            <PrimaryButton
              type="button"
              shape="pill"
              fullWidth
              disabled={loading}
              onClick={onReenviar}
            >
              {loading ? 'Reenviando...' : 'Reenviar código'}
            </PrimaryButton>
          ) : (
            <PrimaryButton
              type="button"
              shape="pill"
              fullWidth
              disabled={loading || codigo.length < length}
              onClick={onConfirmar}
            >
              {loading ? 'Validando...' : submitLabel}
            </PrimaryButton>
          )}
        </Actions>
      </FormBody>
    </Column>
  );
};

export default TokenStep;
